window.addEventListener("load", function() {
  function onSwymLoadCallback(swat) {
    let event = 'sw:addedtowishlist';

    let addedToWishlist = async function(e) {
      var data = e.detail.d;

      const trackingItemData = {
        item_name: data.dt,
        item_id: data.sku,
        quantity: 1,
        price: data.pr,
        currency: 'USD',
        affiliation: data.bt,
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_wishlist",
        ecommerce: {
          currency: 'USD',
          value: data.pr,
          items: [
            {
              ...trackingItemData
            },
          ]
        }
      });
    };
      window._swat.evtLayer.addEventListener(event, addedToWishlist);
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
});